import { render, staticRenderFns } from "./FieldSettingsDialog.vue?vue&type=template&id=41974789&scoped=true&"
import script from "./FieldSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./FieldSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./FieldSettingsDialog.vue?vue&type=style&index=0&id=41974789&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41974789",
  null
  
)

export default component.exports